import {usePlannerQuery} from '../usePlannerQuery'

// Validates that the current user can access the plant referenced in the URL. The backend
// returns 401/403 for unauthorized or unknown plants and usePlannerQuery re-throws so the
// global error boundary surfaces the access error instead of leaving the page stuck loading.
export const usePlantAccessQuery = (plantCode: string) =>
  usePlannerQuery('plantAccess', [plantCode], {enabled: Boolean(plantCode)})
